var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sip-view-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm sip-view-head" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("general.update"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "admin-status-badge",
            class:
              _vm.product.current_version == _vm.product.latest_version &&
              _vm.product.name
                ? "admin-status-badge--success"
                : "admin-status-badge--info",
          },
          [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.product.current_version == _vm.product.latest_version &&
                    _vm.product.name
                    ? "Current"
                    : "Review"
                ) +
                "\n                "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row sip-view-grid" }, [
      _c("div", { staticClass: "col-12 col-lg-8" }, [
        _c("div", { staticClass: "card sip-view-card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.product.current_version == _vm.product.latest_version &&
            _vm.product.name
              ? _c("div", { staticClass: "sip-view-note" }, [
                  _c("strong", [_vm._v("No update available.")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Please check later for a new release.")]),
                ])
              : _c(
                  "div",
                  [
                    !_vm.is_processing
                      ? [
                          _c("div", {
                            staticClass: "sip-view-rich",
                            domProps: { innerHTML: _vm._s(_vm.update_tips) },
                          }),
                          _vm._v(" "),
                          _vm.product.name
                            ? _c("dl", { staticClass: "sip-view-dl mt-3" }, [
                                _c("div", { staticClass: "sip-view-dl__row" }, [
                                  _c("dt", [_vm._v("Version available")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.product.next_release_version)
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sip-view-dl__row" }, [
                                  _c("dt", [_vm._v("Date of release")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.product.next_release_date
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sip-view-dl__row" }, [
                                  _c("dt", [_vm._v("Update size")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getFileSize(
                                          _vm.product.next_release_size
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.product.name
                            ? _c("div", {
                                staticClass: "sip-view-rich mt-2",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.product.next_release_change_log
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "sip-view-actions" }, [
                            !_vm.is_downloaded
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "confirm",
                                        rawName: "v-confirm",
                                        value: { ok: _vm.confirmDownload(0) },
                                        expression: "{ok: confirmDownload(0)}",
                                      },
                                    ],
                                    key: "download",
                                    staticClass:
                                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                                    attrs: { type: "button" },
                                  },
                                  [_vm._v("Download")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.is_downloaded
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "confirm",
                                        rawName: "v-confirm",
                                        value: { ok: _vm.confirmUpdate() },
                                        expression: "{ok: confirmUpdate()}",
                                      },
                                    ],
                                    key: "direct-update",
                                    staticClass:
                                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                    attrs: { type: "button" },
                                  },
                                  [_vm._v("Update")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.is_downloaded
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "confirm",
                                        rawName: "v-confirm",
                                        value: { ok: _vm.confirmDownload(1) },
                                        expression: "{ok: confirmDownload(1)}",
                                      },
                                    ],
                                    key: "download-update",
                                    staticClass:
                                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                    attrs: { type: "button" },
                                  },
                                  [_vm._v("Download & Update")]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "sip-view-note",
                              attrs: { role: "status" },
                            },
                            [
                              _c("strong", [_vm._v("Update in progress")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Don't perform any action till we are performing update!"
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.is_downloading
                                ? _c("span", [
                                    _vm._v(
                                      "Update Size (" +
                                        _vm._s(
                                          _vm.getFileSize(
                                            _vm.product.next_release_size
                                          )
                                        ) +
                                        ") - Downloading....."
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.is_updating
                                ? _c("span", [_vm._v("Updating.....")])
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.is_downloaded
                            ? _c("div", { staticClass: "sip-view-actions" }, [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "confirm",
                                        rawName: "v-confirm",
                                        value: { ok: _vm.confirmUpdate() },
                                        expression: "{ok: confirmUpdate()}",
                                      },
                                    ],
                                    key: "update",
                                    staticClass:
                                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                    attrs: { type: "button" },
                                  },
                                  [_vm._v("Update")]
                                ),
                              ])
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c("div", { staticClass: "card sip-view-card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [_c("product", { attrs: { product: _vm.product, update: "1" } })],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [_vm._v("Review release details and apply updates.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }